/*
 * @Author: princemwang
 * @Date: 2022-06-30 22:15:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-07 15:46:20
 */
import MutedPng from '@/assets/imgs/muted.png';

export const MutedTooltip = ({ visible = false, visibleChange }: { visible: boolean; visibleChange: () => void }) => {
  const value = visible ? 1 : 0;
  const style = {
    transform: `scale(${value})`,
  };
  return (
    <div className="tootip-fix" style={style} onClick={visibleChange}>
      <img src={MutedPng} />
      <span className="tootip-text">Click to turn on sound</span>
    </div>
  );
};
